(function () {
  'use strict';

  var triggerSelector = '[data-stocking-inquiry-trigger]';

  var fields = {
    product_id: 'data-product-id',
    variant_id: 'data-variant-id',
    sku: 'data-variant-sku',
    product_title: 'data-product-title',
    product_url: 'data-product-url'
  };

  function productUrl(value) {
    if (!value) return '';

    try {
      var url = new URL(value, window.location.origin);

      if (
        url.origin !== window.location.origin ||
        url.username ||
        url.password ||
        !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+\/?$/i.test(url.pathname)
      ) {
        return '';
      }

      var variant = url.searchParams.get('variant');

      url.search = '';
      url.hash = '';

      if (variant && /^\d+$/.test(variant)) {
        url.searchParams.set('variant', variant);
      }

      return url.href;
    } catch (error) {
      return '';
    }
  }

  function updateLink(trigger) {
    var base = trigger.getAttribute('data-inquiry-page-url');

    if (!base) return;

    var url = new URL(base, window.location.origin);

    Object.keys(fields).forEach(function (key) {
      var value = trigger.getAttribute(fields[key]) || '';

      if (key === 'product_url') {
        value = productUrl(value);
      }

      if (value) {
        url.searchParams.set(key, value);
      }
    });

    trigger.href = url.pathname + url.search;
  }

  function updateLinks(root) {
    root.querySelectorAll(triggerSelector).forEach(updateLink);
  }

  function initializeForm(root) {
    var form = root.querySelector('[data-availability-form]');

    if (!form || form.dataset.inquiryInitialized === 'true') {
      return;
    }

    form.dataset.inquiryInitialized = 'true';

    var params = new URLSearchParams(window.location.search);

    var limits = {
      product_id: 30,
      variant_id: 30,
      sku: 250,
      product_title: 500,
      product_url: 2000
    };

    var context = {};

    Object.keys(fields).forEach(function (key) {
      var input = form.querySelector(
        '[data-inquiry-field="' + key + '"]'
      );

      if (!input) return;

      var value = params.has(key)
        ? params.get(key)
        : input.value;

      value = String(value || '')
        .trim()
        .slice(0, limits[key]);

      if (
        (key === 'product_id' || key === 'variant_id') &&
        !/^\d+$/.test(value)
      ) {
        value = '';
      }

      if (key === 'product_url') {
        value = productUrl(value);
      }

      input.value = value;
      context[key] = value;
    });
    var source = String(
      params.get('source') || ''
    ).trim();

    var searchQuery = String(
      params.get('query') || ''
    )
      .trim()
      .slice(0, 500);
    var product = form.querySelector(
      '[data-inquiry-field="product_title"]'
    );

    var label = form.querySelector(
      '[data-inquiry-product-label]'
    );

    var inquirySource = form.querySelector(
      '[data-inquiry-source]'
    );

    var originalSearchTerm = form.querySelector(
      '[data-inquiry-search-term]'
    );

    if (product && context.product_title) {
      product.readOnly = true;
      label.textContent = 'Product';
    } else if (
      source === 'search' &&
      searchQuery &&
      product
    ) {
      product.value = searchQuery;
      product.readOnly = false;

      if (inquirySource) {
        inquirySource.value = 'Site Search';
        inquirySource.disabled = false;
      }

      if (originalSearchTerm) {
        originalSearchTerm.value = searchQuery;
        originalSearchTerm.disabled = false;
      }
    }

    var skuRow = form.querySelector(
      '[data-inquiry-sku-row]'
    );

    if (skuRow) {
      skuRow.hidden = !context.sku;
    }

    var link = form.querySelector(
      '[data-inquiry-product-link]'
    );

    if (link && context.product_url) {
      link.href = context.product_url;
      link.hidden = false;
    }


  }

  function initialize(root) {
    updateLinks(root);
    initializeForm(root);
  }

  document.addEventListener(
    'stocking-status:updated',
    function (event) {
      var container =
        event.detail && event.detail.container;

      if (container) {
        updateLinks(container);
      }
    }
  );

  ['click', 'auxclick', 'contextmenu'].forEach(
    function (type) {
      document.addEventListener(
        type,
        function (event) {
          var target = event.target;

          if (!(target instanceof Element)) {
            return;
          }

          var trigger = target.closest(
            triggerSelector
          );

          if (trigger) {
            updateLink(trigger);
          }
        },
        true
      );
    }
  );

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initialize(event.target);
    }
  );

  window.addEventListener(
    'pageshow',
    function () {
      initialize(document);
    }
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initialize(document);
      }
    );
  } else {
    initialize(document);
  }
})();